import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import { arrayUnion, doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { app, db } from '../../config/firebase';

async function publicPushConfig() {
  const snap = await getDoc(doc(db, 'systemConfig', 'platform'));
  const config = snap.exists() ? (snap.data()?.registrationIntegrations || {}) : {};
  return { enabled: Boolean(config.pushEnabled), vapidKey: String(config.webVapidKey || '').trim() };
}

export async function registerPushToken({ uid, requestPermission = false } = {}) {
  if (!uid || typeof window === 'undefined' || !('Notification' in window) || !('serviceWorker' in navigator)) return { supported: false };
  if (!(await isSupported())) return { supported: false };
  const config = await publicPushConfig();
  if (!config.enabled || !config.vapidKey) return { supported: true, configured: false };

  let permission = Notification.permission;
  if (permission === 'default' && requestPermission) permission = await Notification.requestPermission();
  if (permission !== 'granted') return { supported: true, configured: true, permission };

  const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
  const messaging = getMessaging(app);
  const token = await getToken(messaging, { vapidKey: config.vapidKey, serviceWorkerRegistration: registration });
  if (!token) throw new Error('Firebase did not return a push token.');
  await setDoc(doc(db, 'users', uid), {
    fcmToken: token,
    fcmTokens: arrayUnion(token),
    pushPermission: 'granted',
    pushTokenUpdatedAt: serverTimestamp(),
  }, { merge: true });
  return { supported: true, configured: true, permission: 'granted', token };
}

export async function listenForForegroundPush(handler) {
  if (!(await isSupported())) return () => {};
  const messaging = getMessaging(app);
  return onMessage(messaging, (payload) => handler?.(payload));
}

export default { registerPushToken, listenForForegroundPush };
